// export const extractMainMessage = (text) => {
//   if (!text) return ""

//   text = text.split(/<br\s*\/?>/i)[0]
//   text = text.replace(/<[^>]+>/g, "")
//   return text.replace(/\s+/g, " ").trim()
// }

// export const extractMainMessage = (text) => {
//   if (!text) return ""

//   const parts = text.split(/<br\s*\/?>/i)

//   text = parts.length > 1 ? parts.slice(1).join(" ") : parts[0]

//   text = text.replace(/<[^>]+>/g, "")

//   return text.replace(/\s+/g, " ").trim()
// }

// export const extractMainMessage = (text) => {
//   if (!text) return ""

//   text = text.replace(/<br\s*\/?>/gi, "\n")

//   text = text.replace(/<\/p>\s*<p[^>]*>/gi, "\n\n")
//   text = text.replace(/<\/p>/gi, "\n")
//   text = text.replace(/<p[^>]*>/gi, "")

//   text = text.replace(/<[^>]+>/g, "")
//   text = text.replace(/[ \t]+/g, " ")
//   text = text.replace(/\n{3,}/g, "\n\n")

//   return text.trim()
// }

const NOTIFY_HEADER_RE = /^[^\d\n]*\d+[^\S\n]*\n/

export const extractMainMessage = (text) => {
  if (!text) return ""

  text = text.replace(/<br\s*\/?>/gi, "\n")
  text = text.replace(/<\/p>\s*<p[^>]*>/gi, "\n\n")
  text = text.replace(/<\/p>/gi, "\n")
  text = text.replace(/<p[^>]*>/gi, "")
  text = text.replace(/<[^>]+>/g, "")
  text = text.replace(/[ \t]+/g, " ")
  text = text.replace(/\n{3,}/g, "\n\n")
  text = text.trim()

  // Strip the header line only if it matches the pattern
  // (prevents stripping real content that starts with digits)
  const stripped = text.replace(NOTIFY_HEADER_RE, "").trim()
  return stripped.length > 0 ? stripped : text
}
